import React, { Component } from "react";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import {
  contructQueryParam,
  FormatCurrencyWithoutSymbol,
} from "../../../../Services/Utils";
import Api from "../../../../Services/Api";
import { constructSubmitResolvingRequest, fetchKekuranganSO } from "../service";
import KekuranganSODetail from "./kekuranganSODetail";

class KekuranganSO extends Component {
  constructor(props) {
    super(props);
  }

  handleChangeNilaiDiakui = (value, index, tab) => {
    const changedVar = tab === "with_qr" ? "listDataQR" : "listDataTanpaQR";

    this.props.handleSetState((prev) => {
      const updatedList = prev.dataKekurangan[changedVar].map((val, idx) =>
        idx === index
          ? {
              ...val,
              nilaiBeliDiakui: parseFloat(value),
              nilaiDibebankanPerusahaan:
                parseFloat(value - val.nilaiDibebankanKaryawan) || 0,
            }
          : val
      );

      const totals = this.recalculateTotal(updatedList, tab === "with_qr");

      const grandTotal =
        (tab === "with_qr" ? totals.totalQR : prev.dataKekurangan.totalQR) +
        (tab === "with_qr"
          ? prev.dataKekurangan.totalTanpaQR
          : totals.totalTanpaQR);

      return {
        ...prev,
        dataKekurangan: {
          ...prev.dataKekurangan,
          [changedVar]: updatedList,
          ...totals,
          grandTotal,
        },
      };
    });
  };

  handleChangeNilaiKaryawan = (value, index, tab) => {
    const changedVar = tab === "with_qr" ? "listDataQR" : "listDataTanpaQR";

    this.props.handleSetState((prev) => {
      const updatedList = prev.dataKekurangan[changedVar].map((val, idx) =>
        idx === index
          ? {
              ...val,
              nilaiDibebankanKaryawan: parseFloat(value),
              nilaiDibebankanPerusahaan:
                parseFloat(val.nilaiBeliDiakui - value) || 0,
            }
          : val
      );

      const totals = this.recalculateTotal(updatedList, tab === "with_qr");

      const grandTotal =
          (tab === "with_qr" ? totals.totalQR : prev.dataKekurangan.totalQR) +
          (tab === "with_qr"
            ? prev.dataKekurangan.totalTanpaQR
            : totals.totalTanpaQR);

      return {
        ...prev,
        dataKekurangan: {
          ...prev.dataKekurangan,
          [changedVar]: updatedList,
          ...totals,
          grandTotal
        },
      };
    });
  };

  handleExclude = (value, index, tab) => {
    const changedVar = tab === "with_qr" ? "listDataQR" : "listDataTanpaQR";

    this.props.handleSetState((prevValue) => {
      const updatedList = prevValue.dataKekurangan[changedVar].map((val, idx) =>
        idx === index
          ? {
              ...val,
              nilaiBeliDiakui: 0,
              nilaiDibebankanKaryawan: 0,
              exclude: value,
            }
          : val
      );

      const totals = this.recalculateTotal(updatedList, tab === "with_qr");

      const grandTotal =
          (tab === "with_qr" ? totals.totalQR : prevValue.dataKekurangan?.totalQR) +
          (tab === "with_qr"
            ? prevValue.dataKekurangan?.totalTanpaQR
            : totals.totalTanpaQR);

      return {
        ...prevValue,
        dataKekurangan: {
          ...prevValue.dataKekurangan,
          [changedVar]: updatedList,
          ...totals,
          grandTotal
        },
      };
    });
  };

  recalculateTotal = (list, isQR) => {
    const totalKaryawan = list.reduce(
      (acc, item) => acc + (item.nilaiDibebankanKaryawan || 0),
      0
    );

    const totalPerusahaan = list.reduce(
      (acc, item) => acc + (item.nilaiDibebankanPerusahaan || 0),
      0
    );

    return isQR
      ? {
          totalDibebankanKaryawanQR: totalKaryawan,
          totalDibebankanPerusahaanQR: totalPerusahaan,
          totalQR: totalKaryawan + totalPerusahaan,
        }
      : {
          totalDibebankanKaryawanTanpaQR: totalKaryawan,
          totalDibebankanPerusahaanTanpaQR: totalPerusahaan,
          totalTanpaQR: totalKaryawan + totalPerusahaan,
        };
  };

  handlingSetState = (callback) => {
    this.props.handleSetState(callback);
  };

  render() {
    console.log(this.props);
    
    return (
      <>
        <Tabs>
          <TabList>
            <Tab id="dengan_qr">Dengan QR</Tab>
            <Tab id="tanpa_qr">Tanpa QR</Tab>
          </TabList>
          <TabPanel>
            <KekuranganSODetail
              tab="with_qr"
              state={this.props.state}
              onSetState={this.handlingSetState}
              handleSubmit={this.props.handleSubmitResolve}
              handleChangeNilaiDiakui={this.handleChangeNilaiDiakui}
              handleChangeNilaiKaryawan={this.handleChangeNilaiKaryawan}
              handleExclude={this.handleExclude}
              {...this.props}
            />
          </TabPanel>
          <TabPanel>
            <KekuranganSODetail
              tab="without_qr"
              state={this.props.state}
              onSetState={this.handlingSetState}
              handleSubmit={this.props.handleSubmitResolve}
              handleChangeNilaiDiakui={this.handleChangeNilaiDiakui}
              handleChangeNilaiKaryawan={this.handleChangeNilaiKaryawan}
              handleExclude={this.handleExclude}
              {...this.props}
            />
          </TabPanel>
        </Tabs>
      </>
    );
  }
}

export default KekuranganSO;
